var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.route)?_c('a',{staticClass:"entity-id-link",attrs:{"href":_vm.href,"aria-label":_vm.ariaLabel},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.display))]):_c('span',[_vm._v(_vm._s(_vm.display))])
}
var staticRenderFns = []

export { render, staticRenderFns }